import React, { useEffect, useState } from "react";

import styles from "./styles/Intro.module.scss";

import { Image, Spinner } from "react-bootstrap";
import SectionContainer from "../../Components/Container/SectionContainer";
import { Header } from "../../Components/CustomComponent";
import { QUIZ_STATUS, ROLE_TYPE_ENUM, STRING } from "../../constants";
import { useAppContext } from "../../Context/AppContext";
import { useSocket } from "../../Context/SocketContext";
import { ACCOUNT_ENUM } from "./Route";
import { Toast } from "../../Hooks/useToast";

export default function Intro({ data, setPage }) {
    const socket = useSocket();
    const { isSocketConnected } = useAppContext()

    const [isSubmitted, setSubmitted] = useState(undefined)

    useEffect(() => {
        if (isSocketConnected) {
            socket.on('quizJoined_', ({ data, payload }) => {
                const route = data.quiz.status === QUIZ_STATUS.UPCOMING ?
                    ACCOUNT_ENUM.LOBBY :
                    payload.type === ROLE_TYPE_ENUM.AUDIENCE ? ACCOUNT_ENUM.AUDIENCE : ACCOUNT_ENUM.GAME
                setPage(route, {
                    ...data.quiz,
                    user_type: payload.type,
                    audience_id: data.user_quiz.id,
                    coins: data?.user_quiz?.total_coins || 0

                })
            })

            socket.on('join_room_error', (data) => {
                Toast(data.message || STRING.something_went_wrong, 'error', false)
                setSubmitted(undefined)
            })
        }

        return () => {
            socket.dispose('quizJoined_')
            socket.dispose('join_room_error')
        }
    }, [isSocketConnected])

    const handleSubmit = (type) => {
        if (isSubmitted) return;

        setSubmitted(type)
        socket.emit('_joinQuizRoom', {
            quiz_id: data.id,
            type: type
        })
    }

    return (
        <div className={styles.Intro}>
            <SectionContainer classes={`${styles.container} mx-auto`}>
                <div className={`${styles.authTop}`}>
                    <Image
                        src="/assets/tutorial.png"
                        alt="Navbar-Logo-Small"
                        className={`${styles.large}`}
                        responsive
                    />
                </div>
                <div className={`${styles.titleContainer}`}>
                    <div
                        className={styles.logoContainer}
                        onClick={() => handleSubmit(ROLE_TYPE_ENUM.CONTESTANT)}
                    >
                        <Image
                            src="/assets/contestant.png"
                            alt="Navbar-Logo-Small"
                            className={`${styles.center}`}
                            responsive
                        />
                        <div className={`${styles.content} position-absolute w-100 text-center`}>
                            <Header text="Contestant" classes={`${styles.position} tracking-wide`} />
                            {(isSubmitted === ROLE_TYPE_ENUM.CONTESTANT ? <Spinner style={{ color: "white" }} /> : "")}
                        </div>
                    </div>
                    <div
                        className={`${styles.logoContainer} position-relative `}
                        onClick={() => handleSubmit(ROLE_TYPE_ENUM.AUDIENCE)}
                    >
                        <Image
                            src="/assets/audience.png"
                            alt="Navbar-Logo-Small"
                            className={`${styles.center}`}
                            responsive
                        />
                        <div className={`${styles.content} position-absolute w-100 text-center`}>
                            <Header text="Audience" classes={` ${styles.position} tracking-wide`} />
                            {(isSubmitted === ROLE_TYPE_ENUM.AUDIENCE ? <Spinner style={{ color: "white" }} /> : "")}
                        </div>
                    </div>
                </div>
            </SectionContainer>
        </div>
    );
}
